import React from 'react';
import { motion } from 'framer-motion';
export function Description() {
  return <section id="story" className="w-full bg-cream py-20 md:py-28 px-6" data-id="element-30">
      <div className="max-w-2xl mx-auto text-center flex flex-col items-center" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-32">
          <h2 className="font-display text-3xl md:text-4xl mb-5 tracking-wide text-charcoal leading-tight" data-id="element-33">
            Designed for Living
          </h2>

          <div className="w-8 h-[1px] bg-charcoal/20 mx-auto mb-8" data-id="element-34" />

          <div className="space-y-5 text-ink font-serif text-base md:text-[17px] leading-[1.75]" data-id="element-35">
            <p data-id="element-36">
              Step inside a residence where every detail has been meticulously
              curated to elevate the everyday. Light pours through expansive
              windows, illuminating the warm textures and refined finishes that
              define this exceptional family home.
            </p>
            <p data-id="element-37">
              The heart of the home opens gracefully to the outdoors, blurring
              the lines between interior comfort and alfresco serenity. It is a
              space designed not just to be looked at, but to be truly{' '}
              <em className="text-charcoal not-italic" data-id="element-38">lived in</em>—where
              morning coffees are enjoyed in sunlit corners and evenings are
              spent gathering with loved ones.
            </p>
            <p data-id="element-39">
              Positioned in one of Wheelers Hill's most tightly held enclaves,
              this is more than a house; it is a sanctuary that perfectly
              balances architectural elegance with the effortless warmth of
              home.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}